import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { Button } from '@mui/material';
import { authTokenKey } from 'authProvider';
import { HOST } from 'config';
import React from 'react';
import { useRecordContext } from 'react-admin';

export default function DownloadDocButton({ title, type }) {
  const record = useRecordContext() || {};

  function handleClick() {
    const token = localStorage.getItem(authTokenKey);
    fetch(`${HOST}/user/${record.id}/doc/${type}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json()).then(({ url }) => {
      // console.log(data);
      window.open(url, '_blank', 'noopener');
    }).catch((e) => {
      console.log(e);
    });
  }
  if (!record.docs?.[type]) {
    return null;
  }
  return (
    <Button size="small" variant="contained" startIcon={<DownloadRounded />} onClick={handleClick} sx={{ width: 200 }}>{title}</Button>
  );
}
